import axios from "axios";

export const getExams = async (params) => {
  const { data } = await axios.get("/api/exams", { params });
  return data;
};

export const getExam = async (id) => {
  const { data } = await axios.get(`/api/exams/${id}`);
  return data;
};

export const createExam = async (payload) => {
  const { data } = await axios.post("/api/exams", payload);
  return data;
};

export const updateExam = async (id, payload) => {
  const { data } = await axios.put(`/api/exams/${id}`, payload);
  return data;
};

export const deleteExam = async (id) => {
  const { data } = await axios.delete(`/api/exams/${id}`);
  return data;
};

export const publishExam = async (id) => {
  const { data } = await axios.post(`/api/exams/${id}/publish`);
  return data;
};

export const bulkSaveResults = async (id, results) => {
  const { data } = await axios.post(`/api/exams/${id}/results/bulk`, { results });
  return data;
};

export const getExamResults = async (params) => {
  const { data } = await axios.get("/api/exam-results", { params });
  return data;
};

export const getReportCard = async (params) => {
  const { data } = await axios.get("/api/exam-results/report-card", { params });
  return data;
};
